import React, {useContext} from 'react';
import {NavLink} from "react-router-dom";
import tusk from '../../accets/img/task.png'
import myTusk from '../../accets/img/my_task.png'
import msg from '../../accets/img/message.png'
import './Nav.css'
import {Context} from "../../index";
import {observer} from "mobx-react-lite";
import {FriendContext} from "../../App";

const Nav = () => {

    const {taskStore, userStore} = useContext(Context)
    const {messages} = useContext(FriendContext)

    const taskMyUser = taskStore.task.filter(i => i.executor === userStore.user.id && i.status !== "CLOSE")
    const noReadMsgChat = messages.filter(i => i.secondSocketId === userStore.user.socketId && i.isRead === false)

    return (
        <div className="nav__block">
            <div className="link__block">
                <NavLink className="links" to="/job/task">
                    <div className="img__link">
                        <img src={tusk} alt={tusk}/>
                    </div>
                    <div className="name__link">Все задачи</div>
                </NavLink>
            </div>
            <div className="link__block">
                <NavLink className="links" to="/job/myTasks">
                    <div className="img__link">
                        <img src={myTusk} alt={myTusk}/>
                    </div>
                    <div className="name__link">Мои задачи</div>
                    {taskMyUser.length
                        ?
                        <div className="my__task__lgt">
                            <div className="lgt">{taskMyUser.length}</div>
                        </div>
                        : null
                    }

                </NavLink>
            </div>
            <div className="link__block">
                <NavLink className="links" to="/job/message">
                    <div className="img__link">
                        <img src={msg} alt={msg}/>
                    </div>
                    <div className="name__link">Сообщения</div>
                    {noReadMsgChat.length
                        ?
                        <div className="my__task__lgt">
                            <div className="lgt">{noReadMsgChat.length}</div>
                        </div>
                        : null
                    }
                </NavLink>
            </div>
        </div>
    );
};

export default observer(Nav);